import { ApiHelper } from 'cad/common/services/api/api-helper';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {ImbalanceHistory} from 'cad/flowing-gas/view-imbalance/interfaces/imbalance-history-interface';

@Injectable()
export class ViewImbalanceApi {
  public readonly endpoint: string = 'flowing-gas/view-imbalance';

  constructor(private apiHelper: ApiHelper) {}

  public filter (data: any): Observable<any> {
    return this.apiHelper.request(`${this.endpoint}/filter`, { body: data });
  }

  public getImbalanceHistory (data: Partial<ImbalanceHistory>): Observable<ImbalanceHistory[]> {
    return this.apiHelper.request(`${this.endpoint}/history`, { body: data });
  }
}
